import { Component, Input, OnInit } from "@angular/core";
import { finalize } from "rxjs/operators";
import { JiraIssueService } from "../../models/integrations/jira-issue.service";

@Component({
  selector: "ab-jira-integration",
  templateUrl: "./jira.component.html",
})
export class JiraIntegrationComponent implements OnInit {
  @Input() public notice: any;

  public loading: boolean;
  public issue: any;
  public creatingIssue: boolean;
  public error: any;
  public removingIssue: boolean;

  constructor(private jiraIssueService: JiraIssueService) {}

  public ngOnInit() {
    this.loading = true;

    return this.jiraIssueService
      .get(this.notice)
      .pipe(
        finalize(() => {
          delete this.loading;
        }),
      )
      .subscribe((issue: any) => {
        this.issue = issue;
      });
  }

  public createIssue() {
    this.issue = { notice: this.notice };

    this.creatingIssue = true;
    return this.jiraIssueService
      .create(this.issue)
      .pipe(
        finalize(() => {
          delete this.creatingIssue;
        }),
      )
      .subscribe((data: any) => {
        if (data.error) {
          this.error = data.error;
        }
      });
  }

  public removeIssue() {
    this.issue = { notice: this.notice };

    this.removingIssue = true;
    return this.jiraIssueService
      .destroy(this.issue)
      .pipe(
        finalize(() => {
          delete this.removingIssue;
        }),
      )
      .subscribe(() => {
        delete this.issue;
      });
  }
}
